export default {
  Spinner: {
    baseStyle: {},
    sizes: {},
    variants: {},
    defaultProps: {},
  },
};
